import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../../api/api";

export default function EmployeeOrderEditPage() {
    const { id } = useParams();
    const [order, setOrder] = useState(null);
    const [error, setError] = useState("");

    useEffect(() => {
        api
            .get(`/orders/employee/${id}`)
            .then((res) => setOrder(res.data))
            .catch((err) => {
                console.error(err);
                setError(err?.response?.data?.message || "Failed to load order");
            });
    }, [id]);

    if (error) return <p className="text-red-500 text-center">{error}</p>;
    if (!order) return <p className="text-center">Loading...</p>;

    const shipmentStatus = order.shipment?.status || "Created";
    const paymentStatus = order.paymentStatus || order.shipment?.paymentStatus || "Pending";

    return (
        <div className="max-w-3xl mx-auto p-6 bg-white rounded shadow">
            <h2 className="text-xl font-bold mb-4">
                Edit Order #{order.orderNumber || order.id}
            </h2>

            <div className="space-y-2 mb-4">
                <p><b>Status:</b> {shipmentStatus}</p>
                <p><b>Payment:</b> {paymentStatus}</p>
                <p><b>Amount:</b> {order.totalAmount} {order.currency}</p>
                <p><b>Tracking:</b> {order.shipment?.trackingNumber || "—"}</p>
            </div>

            <p className="mb-2 text-yellow-600">
                ⚠ Employees can modify order logistics data here.
            </p>
        </div>
    );
}